import { useQuery } from "react-query";

export default function useProductTypes(filter) {
  const { data: productTypes } = useQuery(["product/product-types", { ...filter }]);
  return productTypes;
}
